import { render, staticRenderFns } from "./BtnBlack.vue?vue&type=template&id=09ef47a4&scoped=true&"
import script from "./BtnBlack.vue?vue&type=script&lang=js&"
export * from "./BtnBlack.vue?vue&type=script&lang=js&"
import style0 from "./BtnBlack.vue?vue&type=style&index=0&id=09ef47a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ef47a4",
  null
  
)

export default component.exports